import React from "react";
import { Message } from "../../../components";
import { COLOR } from "../../../components/theme";

export const InvalidLinkRequest = () => (
  <Message
    severity="warning-or-significant"
    bg={COLOR.RED_100}
    title="Invalid request"
  >
    Your request does not look correct. Please try again.
  </Message>
);
